import Main from './main';
import common from './components/common';

const Brazil = {
  /**
   * Carrosel das capitais e participe
   * All Forecasts
   */
  initCarousel: () => {
    $('[data-carousel="owl.default"]').owlCarousel({
      dots: true,
      lazyLoad: true,
      loop: true,
      responsive: {
        0: {
          items: 1
        },
        1024: {
          items: 1
        }
      }
    })
  }
}

Main.init();
Brazil.initCarousel();
common.backToTopButton()
